import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
import Button from './Button';

const PricingCard = ({ 
  name, 
  price, 
  period, 
  description, 
  features, 
  isPopular = false,
  ctaText = 'Get Started',
  ctaHref = '/contact',
  delay = 0 
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay }}
      viewport={{ once: true }}
      whileHover={{ y: -5 }}
      className={`relative bg-white rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 p-8 border-2 ${
        isPopular ? 'border-primary' : 'border-gray-100'
      }`}
    >
      {isPopular && (
        <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
          <span className="bg-primary text-white px-4 py-1 rounded-full text-sm font-semibold">
            Most Popular
          </span>
        </div>
      )}
      
      <div className="text-center mb-8">
        <h3 className="text-2xl font-bold text-secondary mb-2">{name}</h3>
        <p className="text-gray-600 mb-4">{description}</p>
        <div className="flex items-baseline justify-center">
          <span className="text-4xl font-bold text-primary">${price}</span>
          <span className="text-gray-500 ml-2">/{period}</span>
        </div>
      </div>
      
      <ul className="space-y-4 mb-8">
        {features.map((feature, index) => (
          <li key={index} className="flex items-start">
            {feature.included ? (
              <Check className="w-5 h-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" />
            ) : (
              <X className="w-5 h-5 text-gray-300 mr-3 mt-0.5 flex-shrink-0" />
            )}
            <span className={`text-sm ${feature.included ? 'text-gray-700' : 'text-gray-400'}`}>
              {feature.text}
            </span>
          </li>
        ))}
      </ul>
      
      <Button
        variant={isPopular ? 'primary' : 'secondary'}
        className="w-full"
        href={ctaHref}
      >
        {ctaText}
      </Button>
    </motion.div>
  );
};

export default PricingCard;
